
function installVueGlobal(Vue, globalName, globalValue) {
  const globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype;

  // Don't use Object.assign() to match the Vue.js supported browsers (ECMAScript 5)
  globalPrototype[globalName] = globalValue;
}

const mapper = {
  orderStatusMapper: {
    'REGISTRADO': 'REGISTRADO',
    'EN_PROCESO': 'EN PROCESO',
    'FINALIZADO': 'PREPARADO',
    'NO_REGISTRADO': 'NO REGISTRADO',
    'CANCELADO': 'CANCELADO',
  },
  ordersBackStatusMapper: {
    'REGISTRADO': 'REGISTRADO',
    'NO_REGISTRADO': 'NO REGISTRADO',
    'EN_PROCESO': 'RECIBIDA',
    'FINALIZADO': 'CERRADA',
    'CANCELADO': 'CANCELADO',
  },
  purchaseStatusMapper: {
    'REGISTRADO': 'REGISTRADO',
    'EN_PROCESO': 'RECIBIDA',
    'FINALIZADO': 'CERRADA',
    'NO_REGISTRADO': 'NO REGISTRADO',
    'CANCELADO': 'CANCELADO',
  },
  shipmentStatusMapper: {
    'EN_PROCESO': 'PREPARADO',
    'FINALIZADO': 'EXPEDIDO',
  },
  manifestStatusMapper: {
    'PENDIENTE': 'PENDIENTE',
    'ENTREGADO': 'ENTREGADO',
  }
}


// eslint-disable-next-line no-unused-vars
export default function install(Vue, options={}) {
  installVueGlobal(Vue, '$statusMapper', mapper);
}